import { render, staticRenderFns } from "./App.vue?vue&type=template&id=42e97fde&scoped=true&lang=pug&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./App.vue?vue&type=style&index=1&id=42e97fde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e97fde",
  null
  
)

export default component.exports